import { createFileRoute } from '@tanstack/react-router';

import type { BalanceSheetId } from '@/../convex/types';
import { BalanceSheetTable } from '@/components/BalanceSheetTable';
import { AuthenticatedRoute } from '@/lib/authenticatedRoute';

function TablePage() {
  const { id } = Route.useParams() as { id: BalanceSheetId };
  return (
    <div className="py-4">
      <BalanceSheetTable id={id} />
    </div>
  );
}

export const Route = createFileRoute('/balance-sheet/$id/table')({
  component: AuthenticatedRoute(TablePage),
});
